import { render, staticRenderFns } from "./StowageInstructionPage.vue?vue&type=template&id=398fcad4&scoped=true"
import script from "./StowageInstructionPage.vue?vue&type=script&ts=true&lang=js"
export * from "./StowageInstructionPage.vue?vue&type=script&ts=true&lang=js"
import style0 from "./StowageInstructionPage.vue?vue&type=style&index=0&id=398fcad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398fcad4",
  null
  
)

export default component.exports